import { TextField, Dialog } from "@material-ui/core";
import { Input } from "antd";
import styled from "styled-components";

export const MakerWrapper = styled.div`
  /* max-width: 440px; */
  /* justify-content: center; */
  /* text-align: center; */
  width: 100%;
  height: 100%;
  /* min-height: calc(100vh - 104px - 60px); */
  display: flex;
  flex-flow: column;
  gap: 1em;
  /* justify-content: space-between; */
  margin: auto;
  .disabled {
    background: #efefef;
    color: #a6a6a6;
    cursor: not-allowed;
  }
  .btnDisabled {
    background: #e4e4e494;
    color: #a6a6a6;
    border-color: #e4e4e494;
  }

  form {
    width: 100%;
  }
`;

export const CustomField = styled(Input)`
  width: 100%;
  /* margin-right: 1rem; */

  input {
    width: 100%;
    background: transparent;
    height: 44px;
    border-radius: 4px;
    border: 1px solid #c4c4c4;
    box-shadow: none !important;
    font-size: 15px;
  }
`;
export const OrderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1em;

  .inputWrap {
    width: 70%;

    input {
      width: 100%;
      background: transparent;
      height: 44px;
      border-radius: 4px;
      border: 1px solid #c4c4c4;
      box-shadow: none !important;
      font-size: 15px;
    }
  }

  .btnWrap {
    width: 30%;
    button {
      width: 100%;
      height: 44px;
      border-radius: 4px;
      border: 1px solid #2f65cb;
      background: transparent;
      color: #2f65cb;
      font-weight: 500;
      font-size: 15px;
    }
  }
  /* > button {
    height: 34px;
  } */
  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    background-color: white;
    padding: 0 5px;
    transform: translate(14px, -7px) scale(0.74);
  }
  .MuiInputLabel-outlined {
    font-size: 14px;
    transform: translate(14px, 12px) scale(1);
  }

  .MuiOutlinedInput-root {
    height: 40px;
  }
  .MuiOutlinedInput-input {
    padding: 12.5px 14px;
  }
  @media screen and (max-width: 568px) {
    /* flex-flow: column; */
    > button {
      margin-top: 10px;
    }
  }
`;

export const CustomDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 300px;
  }
`;
